import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "body", "chevron"]
  static values = { id: String, restore: { type: Boolean, default: true } }

  connect() {
    this.boundReapplyAfterMorph = this.reapplyAfterMorph.bind(this)
    document.addEventListener("turbo:morph", this.boundReapplyAfterMorph)
    this.applyClientState()
  }

  disconnect() {
    if (this.boundReapplyAfterMorph) document.removeEventListener("turbo:morph", this.boundReapplyAfterMorph)
  }

  reapplyAfterMorph() {
    this.applyClientState()
  }

  applyClientState() {
    if (!this.hasBodyTarget || !this.hasHeaderTarget) return
    if (!this.restoreValue) return this.reflect()

    const stored = sessionStorage.getItem(this.storageKey)
    if (stored !== null) this.apply(stored === "open")
    else this.reflect()
  }

  toggle(event) {
    if (this.carriesAControlOfItsOwn(event)) return

    event.preventDefault()
    this.apply(this.bodyTarget.hidden)
  }

  carriesAControlOfItsOwn(event) {
    const control = event.target.closest("input, select, textarea, button, a, label")
    return Boolean(control) && control !== event.currentTarget
  }

  reveal(event) {
    if (event.detail?.id !== this.idValue) return
    this.apply(true)
    this.element.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  apply(open) {
    this.bodyTarget.hidden = !open
    this.remember(open)
    this.reflect()
  }

  remember(open) {
    if (!this.restoreValue) return
    sessionStorage.setItem(this.storageKey, open ? "open" : "closed")
  }

  reflect() {
    const open = !this.bodyTarget.hidden
    this.headerTarget.setAttribute("aria-expanded", open ? "true" : "false")
    this.element.setAttribute("data-disclosure-state", open ? "open" : "collapsed")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-90", open)
    }
  }

  get storageKey() {
    return `cup:disclosure:${this.idValue}`
  }
}
